var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-sheet',{staticClass:"g-card purple lighten-1 mx-1 mb-5 pa-2",attrs:{"shaped":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }